import { Activity } from "lucide-react"
import { EmptyState } from "@/components/common/EmptyState"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

export function RecentActivitySection() {
  return (
    <section>
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Ostatnia aktywność</CardTitle>
        </CardHeader>
        <CardContent>
          <EmptyState
            icon={Activity}
            title="Brak danych"
            description="Timeline aktywności pojawi się tutaj po pierwszych operacjach w systemie."
          />
        </CardContent>
      </Card>
    </section>
  )
}
